import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { saveAs } from 'file-saver'
import {
    Modal,
    Skeleton,
    Table,
    Select,
    Space,
} from 'antd'
import { LoadingOutlined, } from '@ant-design/icons'

// Components
import PageHeader from "../../Reusable/PageHeader"
import ReportTable from './ReportTable'
import { Flex, FlexColumn } from '../../Reusable/Container';
import { Text } from '../../Reusable/Text'
import { LabeledInput } from '../../Reusable/Input'
import { ErrorAlert } from '../../Reusable/Alert'
import AccountStatement from '../AccountStatement/Index'
import SearchAndFilter from '../SearchAndFilter'

// Util
import { apiGET, apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'

// Actions
import { withTheme } from 'styled-components'

import CSV from '../../../Images/csv.png'
import { getDate } from '../../../Utils/util'
import ModalClose from '../../../Images/modal-close.png'

const { Option } = Select

const dFormat = "YYYY-MM-DD"
const pageSize = 50;

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

class Index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            customize: true,
            loadingPassThrough: true,
            loadingTransactions: true,
            loadingReport: true,
            pagination: {
                current: 1,
                pageSize: pageSize,
            },
            modalWidth: 900,
            dateType: "Year to Date",
            dailyReportItemList: []
        }

        this.fetchData = this.fetchData.bind(this)
    }

    componentDidMount() {
        this.fetchData({ fromDate: null, toDate: null })
    }

    componentDidUpdate(prevProps) {
        let { location } = this.props
        var state = location.state ? location.state : {}
        if (state.reloadData) {
            this.props.location.state = {}
            this.fetchData({ fromDate: null, toDate: null })
        }
    }

    fetchData(options) {
        let { fromDate, toDate, pagination, fromApply } = options;

        let fetchOptions = {
            sortFieldDirection: 'DESC',
            fromDate: fromDate,
            toDate: toDate,
            size: this.state.pagination.pageSize,
            page: this.state.pagination.current - 1,
            download: false,
        }
        
        if (pagination) {
            fetchOptions.size = pagination.pageSize
            fetchOptions.page = pagination.current - 1
        }

        if (fromDate) {
            fetchOptions.fromDate = fromDate
            fetchOptions.toDate = toDate
        }
        this.setState({ loading: true })

        if (!pagination) {
            pagination = this.state.pagination
        }
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getDailyReport`, {}, fetchOptions, (err, resp) => {
            try {
                const data = resp || {}
                if (data) {
                    console.log('lsm/getDailyReport: ', resp)
                    var dailyReportItemList = fromApply ? data.dailyReportItemList : this.state.dailyReportItemList.concat(data.dailyReportItemList);
                    var moreItem = dailyReportItemList.length == data.count ? false : true
                    this.setState({
                        ...options,
                        loading: false,
                        dailyReportItemList: dailyReportItemList || [],
                        moreToLoad: moreItem,
                        pagination: {
                            ...pagination,
                            total: data.count,
                        },
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/counterparty err", error, resp)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    handleDateTypeSelection = (val) => {
        let { fromDate, toDate } = this.getDate(val)

        this.setState({
            dateType: val,
        })
        this.fetchData({ fromDate, toDate })
    }

    handleDateRange = (dates) => {
        this.fetchData({
            fromDate: dates[0].format(dFormat),
            toDate: dates[1].format(dFormat),
            dateType: "Custom"
        })
    }

    disabledDate = (current) => {
        // Can not select days after today
        return current > moment().endOf('day');
    }

    loadMoreData = () => {
        var updatedState = {
            dateType: "Custom",
            loading: true,
            pagination: {
                current: this.state.pagination.current + 1,
                pageSize: pageSize,
            },
            fromApply: false
        }
        this.fetchData({ ...this.state, ...updatedState })
    }

    render() {
        const { loading, transactions, passThrough,
            loadingTransactions, loadingPassThrough, moreToLoad } = this.state

        const Attributes = this.props.aionStore.Attributes || {}
        const businessAttributes = Attributes.Businesses || {}
        const inventoryLOC = businessAttributes.InventoryLOCEnabled

        const columns = [
            {
                title: 'Date',
                dataIndex: 'Date',
                key: 'Date',
                render: date => (moment(date).format('MMM Do, YYYY')),
                width: '100pt'
            },
            {
                title: 'Customer',
                dataIndex: 'CustomerName',
                key: 'CustomerName',
            },
            {
                title: 'Description',
                dataIndex: 'DisplayDescription',
                key: 'Description',
            },
            {
                title: 'Type',
                dataIndex: 'DisplayType',
                key: 'Type',
            },
            {
                title: 'Credit/Debit',
                dataIndex: 'Amount',
                key: 'Amount',
                render: amount => (<b>{formatter.format(amount)}</b>),
                width: '100pt'
            },
            {
                title: 'Running Balance',
                dataIndex: 'BalanceEnd',
                key: 'BalanceEnd',
                render: balanceEnd => (formatter.format(balanceEnd)),
                width: '100pt'
            },
        ]

        const passThroughColumns = [
            {
                title: 'Date',
                dataIndex: 'Date',
                key: 'Date',
                render: date => (moment(date).format('MMM Do, YYYY')),
                width: '100pt'
            },
            {
                title: 'Customer Name',
                dataIndex: 'CustomerName',
                key: 'CustomerName',
            },
            {
                title: 'Type',
                dataIndex: 'DisplayType',
                key: 'Type',
            },
            {
                title: 'Description',
                dataIndex: 'Description',
                key: 'Description',
            },
            {
                title: 'Amount',
                dataIndex: 'AmountStr',
                key: 'AmountStr',
                render: amount => (`$${amount}`),
                width: '100pt'
            },
        ]

        return (
            <FlexColumn className='main-padding'>
                <PageHeader
                    titleText="Credit"
                    subtitle={inventoryLOC === true ? 'Inventory line of credit' : "ABL Credit"}
                />

                <ReportTable
                    componentType="Reports"
                    pagination={false}
                    moreToLoad={moreToLoad}
                    onLoadMore={() => this.loadMoreData()}
                    loading={loading}
                    pageSize={pageSize}
                    reports={this.state.dailyReportItemList || []}
                    fetchReport={this.fetchData}
                    ctaContent={
                        <Flex start fullWidth gap='24px'>
                            <SearchAndFilter
                                clearAll={() => {
                                    this.setState({
                                        dailyReportItemList: [], 
                                        fromDate: null, toDate: null,
                                        pagination: {
                                            current: 1,
                                            pageSize: pageSize,
                                        },
                                    })
                                    this.fetchData({ fromDate: null, toDate: null, fromApply: false, pagination: {
                                        current: 1,
                                        pageSize: pageSize,
                                    }, })
                                }}
                                fetchData={this.fetchData}
                                pageSize={pageSize}
                            />
                        </Flex>
                    }
                />

                <Modal
                    visible={this.state.showPaymentModal}
                    footer={null}
                    closable={true}
                    width={this.state.modalWidth}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showPaymentModal: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <Table
                        tableLayout='auto'
                        columns={columns}
                        dataSource={transactions}
                        loading={loadingTransactions}
                    />
                </Modal>
                <Modal
                    visible={this.state.showPassThroughModal}
                    footer={null}
                    closable={true}
                    width={this.state.modalWidth}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showPassThroughModal: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <Table
                        tableLayout='auto'
                        columns={passThroughColumns}
                        dataSource={passThrough}
                        loading={loadingPassThrough}
                    />
                </Modal>
                <Modal
                    visible={this.state.showAccountStmtModal}
                    footer={null}
                    onCancel={() => { this.setState({ showAccountStmtModal: false }) }}
                    width={500}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <AccountStatement business={this.props.aionStore.BusinessUniqueKey} modal />
                </Modal>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.creditAppReducer,
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))